import Controller from "./contractors.controller";
import template from "./contractors.html";

const contractors = {
  template,
  controller: Controller,
};

export default contractors;



// WEBPACK FOOTER //
// ./src/pages/contractors/contractors.component.js